// extracted by mini-css-extract-plugin
export var required = "_fw-0";